module.exports = __webpack_public_path__ + "static/media/single_post_img.5489ca11.jpg";